
export const defaults = Object.freeze({
	timeout: 60_000,
	maxRequestBytes: 10_000_000,
})

